import {PatientSphereState} from './models/patient-sphere';
import {firstValueFrom, map, Observable} from 'rxjs';
import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngxs/store';
import {AuthActions, AuthState, IAuthToken, IUser} from './models/auth';
import {environment} from '../environments/environment';
import {StorageService} from './services/storage/storage.service';
import {PatientStatusEnum} from './models/patient';
import {ShepherdService} from 'angular-shepherd';
import Typebot from 'typebot-js';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'clinica-front';
  isExpert$: Observable<boolean> = this.store.select<boolean>(AuthState.getIsExpert);
  viewBubble$: Observable<boolean> = this.store.select<boolean>(PatientSphereState.getShowBubble).pipe(
    map((showBubble) => {
      this.styleChatBubble(showBubble);
      return showBubble;
    })
  );
  constructor(
    private router: Router,
    private store: Store,
    private storageService: StorageService,
    private activatedRoute: ActivatedRoute,
    private shepherdService: ShepherdService
  ) {
    // this.onChangeRouter();
    console.log('app version', environment.APP_VERSION);
  }

  ngOnInit(): void {
    Typebot.initBubble({
      url: 'https://bot.apispot.net/delie-soporte-v1',
      proactiveMessage: { textContent: '¿Tienes dudas?', delay: 3000 },
      button: { color: '#2C8096' },
    });
  }

  async initValuesHttp(): Promise<void> {
    const userToken: IAuthToken = this.storageService.getLocalItem<{ token: string, user: IUser }>('user');
    if (!userToken) return;
    if ((!userToken || !userToken.user || !userToken.token) || (!userToken?.user?.patients && !userToken?.user?.experts)) return;
    const clinicId = userToken.user.experts ? userToken.user.experts[0].clinicId : userToken.user.patients[0].clinicId;
    const queryParams = this.activatedRoute.snapshot.queryParams;
    const userInvitedFromAnotherClinic = queryParams.new === 'false' || queryParams.new === 'true';
    const [patient] = userToken?.user.patients ?? [];
    const hasNotHabits = patient?.habits ? JSON.stringify(patient?.habits) === '{}' : false;
    const statusActive = userToken?.user?.patients ? patient.status === PatientStatusEnum.ACTIVE : false;
    // obtener los tours para el experto
    if (patient?.status === PatientStatusEnum.PRECREATED || hasNotHabits || userInvitedFromAnotherClinic) {
      await this.router.navigate(['clinic', 'onboarding', clinicId], {
        queryParams: { invite: true, hasNotHabits: hasNotHabits && statusActive }
      });
      return;
    } else {
      await firstValueFrom((this.store.dispatch(new AuthActions.SetUser(userToken.user))));
      await this.router.navigate([`clinic/${clinicId}/summary`]);
    }
  }

  ngAfterViewInit(): void {

  }


  styleChatBubble(showPatientBubble: boolean): void {
      if (showPatientBubble) {
        document.querySelector('#typebot-bubble-button')?.setAttribute('style', 'bottom: 10px; right: 70px; background-color: rgb(44, 128, 150);z-index: 10;');
        document.querySelector('.proactive-message')?.setAttribute('style', 'bottom: 75px; right: 75px;');
      } else {
        document.querySelector('#typebot-bubble-button')?.setAttribute('style', 'background-color: rgb(44, 128, 150);z-index: 10;');
        document.querySelector('.proactive-message')?.setAttribute('style', 'bottom: 75px;');
      }
  }

}
